import { bool, func, object } from 'prop-types';
import React from 'react';
import { Button } from 'reactstrap';

import api from '../../REST/api';
import withApiRequest from '../../REST/with-api-request';

function ExportAllMerchants({ onRequest, loading, tableFilters, ...rest }) {
  return (
    <Button
      disabled={loading}
      onClick={() => onRequest({ search: { ...tableFilters } })}
      {...rest}
    >
      Export
    </Button>
  );
}

ExportAllMerchants.propTypes = {
  onRequest: func.isRequired,
  loading: bool.isRequired,
  tableFilters: object, // eslint-disable-line react/forbid-prop-types,
};

ExportAllMerchants.defaultProps = {
  tableFilters: undefined,
};

export default withApiRequest({
  query: api.exportZMSAMMerchant,
  error: 'flash',
  successMessage: 'Email with all merchants is being prepared',
})(ExportAllMerchants);
